import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HugerteEditorComponent } from './hugerte-editor.component';

/**
 * Módulo do wrapper do Hugerte.
 *
 * @example
 * import { HugerteEditorModule } from 'src/app/components/hugerte-editor/hugerte-editor.module';
 */
@NgModule({
  declarations: [HugerteEditorComponent],
  imports: [CommonModule],
  exports: [HugerteEditorComponent]
})
export class HugerteEditorModule {}
